(() => {
  const root = document.documentElement;
  if (!root) {
    return;
  }

  const findHeader = () =>
    document.querySelector('[data-section-type="header"]') ||
    document.querySelector('header.sticky') ||
    document.querySelector('header');

  const update = () => {
    const header = findHeader();
    if (!header) {
      return;
    }
    const { height } = header.getBoundingClientRect();
    root.style.setProperty('--header-height', `${height}px`);
  };

  let observer;

  const attachObserver = () => {
    const header = findHeader();
    if (!header || typeof ResizeObserver !== 'function') {
      return;
    }
    if (!observer) {
      observer = new ResizeObserver(update);
    } else {
      observer.disconnect();
    }
    observer.observe(header);
  };

  window.addEventListener('load', () => {
    update();
    attachObserver();
  });

  document.addEventListener('shopify:section:load', () => {
    update();
    attachObserver();
  });

  window.addEventListener('resize', update);
  update();
})();
